'use client'

import classNames from 'classnames'
import React, { useMemo, useState } from 'react'
import { Pagination } from 'swiper/modules'
import { Swiper, SwiperClass, SwiperSlide } from 'swiper/react'

import SliderNavigation from '~/layouts/shared/slider-navigation'
import { ISlideIconItem } from '~/types/strapi'

import SliderItem from './slider-item'

interface SlideListWrapen {
  key: string
  items: ISlideIconItem[]
}

interface Props {
  sliderKey: string
  items: ISlideIconItem[]
  itemSize: 'normal' | 'large'
  hidden?: boolean
}

const TabSliderDesktop: React.FC<Props> = ({
  items,
  sliderKey,
  itemSize,
  hidden,
}) => {
  const [slider, setSlider] = useState<SwiperClass>()
  const [isBackDisable, setBackDisable] = useState(true)
  const [isNextDisable, setNextDisable] = useState(false)
  const [isPaginationEnabled, setPaginationEnabled] = useState(true)

  const listWrapen = useMemo(() => {
    const list: SlideListWrapen[] = []
    const wrapenSize = itemSize === 'large' ? 3 : 4

    for (let index = 0; index < items.length; index += wrapenSize) {
      const endIndex = index + wrapenSize
      const key = `slide-list-${index}-${endIndex}`

      list.push({
        key,
        items: items.slice(index, endIndex),
      })
    }

    return list
  }, [items, itemSize])

  const paginationName = `slider-pagination-${sliderKey}-desktop`

  return (
    <div className="hidden lg:block w-full">
      <Swiper
        slidesPerView={1}
        modules={[Pagination]}
        className={classNames({
          'cursor-grab active:cursor-grabbing': listWrapen.length > 1,
        })}
        pagination={{
          el: '.' + paginationName,
          clickable: true,
          renderBullet: (index, className) => {
            return '<span class="' + className + '"></span>'
          },
        }}
        onInit={(swiper) => {
          setSlider(swiper)
          setPaginationEnabled(!swiper.isLocked)
        }}
        onSlideChange={(swiper) => {
          setBackDisable(swiper.isBeginning)
          setNextDisable(swiper.isEnd)
          setPaginationEnabled(!swiper.isLocked)
        }}
      >
        {listWrapen.map((wrapen) => (
          <SwiperSlide key={wrapen.key}>
            <div
              className={classNames('container grid gap-5', {
                'grid-cols-3': itemSize === 'large',
                'grid-cols-4': itemSize === 'normal',
              })}
            >
              {wrapen.items.map((item) => (
                <div key={`icons-slide-desktop-${item.id}`}>
                  <SliderItem {...item} />
                </div>
              ))}
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      {isPaginationEnabled && (
        <SliderNavigation
          pagination={paginationName}
          onClickBack={() => slider.slidePrev()}
          onClickNext={() => slider.slideNext()}
          isBackDisable={isBackDisable}
          isNextDisable={isNextDisable}
          hidden={hidden}
        />
      )}
    </div>
  )
}

export default TabSliderDesktop
